/** Claim a group-routed approval (Accept → mine): self-assigns the caller as
 *  its approver, moving it from the group's shared queue to their pending list. */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api/generated";

export function useClaimApproval() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (approvalId: string) =>
            api.api_ApprovalRequests_claim_create(undefined, { params: { id: approvalId } }),
        onSuccess: () => {
            // Covers ["approvals", "claimable"] and ["approvals", "my-pending"].
            queryClient.invalidateQueries({ predicate: (q) => q.queryKey[0] === "approvals" });
        },
    });
}
